var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 8.66666V7.1046C13.3334 6.55956 13.3334 6.28706 13.2319 6.04203C13.1304 5.79701 12.9377 5.60432 12.5523 5.21895L9.39468 2.06125C9.06208 1.72866 8.89581 1.56236 8.68975 1.46383C8.64688 1.44333 8.60301 1.42514 8.55821 1.40933C8.34281 1.33333 8.10768 1.33333 7.63728 1.33333C5.47396 1.33333 4.39229 1.33333 3.65963 1.92404C3.51162 2.04338 3.3768 2.1782 3.25746 2.32621C2.66675 3.05887 2.66675 4.14054 2.66675 6.30389V8.66666M8.66675 1.66666V1.99999C8.66675 3.88561 8.66675 4.82842 9.25255 5.41421C9.83835 5.99999 10.7811 6 12.6667 6H13.0001",
    stroke: "#34C759",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.6667V13.3333C7 13.9619 7 14.2761 7.19527 14.4714C7.39053 14.6667 7.7048 14.6667 8.33333 14.6667H9.33333",
    stroke: "#34C759",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 10.6667L4.00008 12.6667M4.00008 12.6667L5.33341 14.6667M4.00008 12.6667L5.33341 10.6667M4.00008 12.6667L2.66675 14.6667",
    stroke: "#34C759",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 10.6667H11.6667C11.2985 10.6667 11 10.9651 11 11.3333V12C11 12.3682 11.2985 12.6667 11.6667 12.6667H12.6668C13.035 12.6667 13.3335 12.9651 13.3335 13.3333V14C13.3335 14.3682 13.035 14.6667 12.6668 14.6667H11",
    stroke: "#34C759",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExportation);
export default __webpack_public_path__ + "static/media/iconExportation.3422706c01b94bae8e040b3875e085d3.svg";
export { ForwardRef as ReactComponent };